import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.726.775a2.616 2.616 0 0 1 2.616 2.617v.834H16l-1 11H1l-1-11h1.11v-.834A2.616 2.616 0 0 1 3.725.775Zm-.9 12.45h2.007l-.12-4h-2.25l.363 4Zm4.008 0h2.41l.121-4H6.713l.121 4Zm4.411 0h1.928l.364-4h-2.172l-.12 4Zm-8.873-5h2.31l-.06-2H2.19l.182 2Zm4.312 0h2.71l.061-2H6.623l.06 2Zm4.712 0h2.232l.182-2h-2.354l-.06 2Zm-7.67-6.15c-.639 0-1.156.517-1.157 1.155v.996h2.313V3.23c0-.638-.518-1.156-1.156-1.156Zm7.918-1.3a2.614 2.614 0 0 1 2.607 2.45h-1.45a1.157 1.157 0 0 0-2.312 0H9.036a2.613 2.613 0 0 1 2.608-2.45Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconComfortBanya16 = createIcon(IconComponent);